var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgZixxarLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 399.757,
    height: 400,
    viewBox: "0 0 399.757 400",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.146,
    y1: 0.146,
    x2: 0.986,
    y2: 0.986,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00a7ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#842bd0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#ff007e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffb000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.5,
    y1: 1.073,
    x2: 0.5,
    y2: 0.073,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00a7ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#842bd0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#ff007e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.803,
    stopColor: "#ff474b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.895,
    stopColor: "#ff8023"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.963,
    stopColor: "#ffa30a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffb000"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "zixxar-x-logo",
    transform: "translate(-400.4 -406.99)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_79389",
    "data-name": "Path 79389",
    d: "M800.157,581.231V465.776l-58.776-58.785-2.8,2.8L796.2,467.416V579.593l-54.863,54.765-57.065-57.068-2.8,2.8,57.067,57.07-108,108.1L572.65,687.272l-2.8,2.794,57.894,58-54.913,54.966H460.821L403.2,745.212l-2.8,2.794,58.774,58.984H574.467l56.069-56.124,56.022,56.124h113.6V693.181l-56.023-56.025ZM796.2,694.82V803.03H688.2l-54.869-54.968,108-108.106ZM460,580.4l-59.6-59.6,2.8-2.8L460,574.8,568.189,466.6l-56.993-56.8,2.794-2.8,59.8,59.6Z",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79390",
    "data-name": "Path 79390",
    d: "M741.379,520.8,514,748.016H400.4V634.41L627.786,407H741.379V520.8Zm-340.979,0L514,407H400.4V520.8ZM741.379,634.41,627.786,748.016H741.379V634.41Z",
    transform: "translate(0 -0.008)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_18989",
    "data-name": "Group 18989",
    transform: "translate(466.154 474.836)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_79391",
    "data-name": "Path 79391",
    d: "M796.866,1827.088l-.931-64.349-30.523,30.523-5.661-5.661,42.08-42.08,5.661,5.661.931,64.349,32.895-32.895,5.661,5.661-44.452,44.452Z",
    transform: "translate(-759.75 -1568.439)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79392",
    "data-name": "Path 79392",
    d: "M1031.84,1666.348l8.3-8.3,6.661,6.661-8.3,8.3Zm11.989,11.991,8.3-8.3,31.974,31.974-8.3,8.3Z",
    transform: "translate(-982.052 -1496.975)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79393",
    "data-name": "Path 79393",
    d: "M1113.776,1399.178l30.212,1.762-1.762-30.212,10.668-10.668,2.425,41.541,41.541,2.423-10.668,10.668-30.212-1.762,1.762,30.212-10.668,10.668-2.423-41.541-41.541-2.425Z",
    transform: "translate(-1040.281 -1253.511)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79394",
    "data-name": "Path 79394",
    d: "M1398.816,1114.138l30.212,1.762-1.762-30.212,10.668-10.668,2.424,41.541,41.541,2.423-10.668,10.668-30.212-1.762,1.762,30.212-10.668,10.668-2.423-41.541-41.541-2.424Z",
    transform: "translate(-1273.164 -1020.629)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79395",
    "data-name": "Path 79395",
    d: "M1781.907,998.757c-7.66-7.66-1.733-13.586,4.194-19.513l14.225-14.225-5-5c-2-2-3.48-.516-4.963.964l-20.743,20.743-5-5,20.152-20.152c5.927-5.927,11.854-11.854,19.513-4.194L1828.61,976.7l-22.521,22.521c-5.927,5.927-11.854,11.854-19.513,4.194Zm18.589-3.932,14.818-14.818-9.993-9.993L1790.5,984.832c-1.482,1.482-2.962,2.962-.964,4.962l5.995,5.995C1797.532,997.787,1799.014,996.3,1800.5,994.825Z",
    transform: "translate(-1580.755 -917.467)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79396",
    "data-name": "Path 79396",
    d: "M2004.03,805.581c-7.66-7.66-1.733-13.586,4.194-19.513l8.3-8.3,5,5-8.889,8.889c-1.482,1.482-2.964,2.964-.964,4.963l24.979,24.979-8.3,8.3Z",
    transform: "translate(-1773.379 -777.77)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgZixxarLogo);
export default __webpack_public_path__ + "static/media/zixxar-logo.eb2707d6903300b54e5196b977ff5247.svg";
export { ForwardRef as ReactComponent };